import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
const MyVehicleOwnership = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        ReadAxios({
            completeURL: `${process.env.REACT_APP_MASTER_API}/vehicleOwnershipType`
          }).then((result) => {
            result?.data?.resultSet?.length && setcontent(result?.data?.resultSet) ;
            setloading(false)
          })
    }, [])    

    let options = []
    if(props.options){
        options = props.options
    }else{
        if (content.length > 0) {
            content.map((object, index) => {
                let temp = {}
                temp.key = object.vehicleOwnershipTypeId
                temp.text = object.vehicleOwnershipTypeName
                let value = object.vehicleOwnershipTypeId
                if(props.nameValue){
                    let name = object.vehicleOwnershipTypeName.split(" ")
                    value = name?.length ? name[0] : object.vehicleOwnershipTypeId
                }
                temp.value = value
                return options[index] = temp
            })
        }
    }

    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (
        <Dropdown
            selection
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            {...props}
        />

    )
}

export default MyVehicleOwnership